import { SxProps } from "@mui/material"
import { Theme } from "@mui/system"

export const interestsList: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "360px",
  gap: "16px",
  position: "relative",
  padding: "0",
}

export const interestsListItem: SxProps<Theme> = {
  gap: "8px",
  maxWidth: "100%",
  height: "40px",
  minHeight: "40px",
  padding: "0",
  backgroundColor: "inherit",
}

export const interestsListButton: SxProps<Theme> = {
  gap: "8px",
  display: "grid",
  gridTemplateColumns: "24px 1fr 24px",
  maxWidth: "100%",
  height: "100%",
  width: "100%",
  padding: "0 16px",
  margin: "0",
  alignItems: "center",
  color: "var(--Schemes-On-Surface)",
  "&:hover": {
    color: "var(--Schemes-Primary)",
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
  },
  "&:active": {
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
  },
  span: {
    padding: "0",
  },
}

export const interestsListAllButton: SxProps<Theme> = {
  gap: "8px",
  display: "grid",
  gridTemplateColumns: "1fr 38px",
  maxWidth: "100%",
  height: "100%",
  width: "100%",
  padding: "0 16px",
  margin: "0",
  alignItems: "center",
  color: "var(--Schemes-On-Surface)",
  "&:hover": {
    color: "var(--Schemes-Primary)",
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
    transition: "all 0.3s ease",
      "& .MuiSwitch-thumb": {
        color: "var(--Schemes-Primary)",
      },
      "& .MuiSwitch-track": {
        border: "solid 2px var(--Schemes-Primary)",
      }
  },
  "&:active": {
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
  },
  span: {
    padding: "0",
  },
}

export const interestsSaveButton: SxProps<Theme> = {
  fontFamily: "Roboto, sans-serif",
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "20px",
  textAlign: "center",
  color: "var(--Schemes-Primary)",
  padding: "10px 16px",
  gap: "8px",
  borderRadius: "100px",
  minHeight: "40px",
  maxWidth: "100%",
  minWidth: "100px",
  ":hover": {
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
  },
}
